<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 2c.663 0 1.2.537 1.2 1.2v.3h.3c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-.3v1.282l6.498 4.642c.539.385.664 1.134.279 1.674-.386.539-1.135.664-1.675.279L18 13.56v6.04h2.8c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2H3.2c-.663 0-1.2-.537-1.2-1.2 0-.663.537-1.2 1.2-1.2h2.79999v-6.516l-.351.225c-.558.359-1.3.197-1.658-.36-.359-.558-.197-1.3.36-1.658L10.8 7.145V5.9h-.3c-.66301 0-1.20001-.537-1.20001-1.2 0-.663.537-1.2 1.20001-1.2h.3v-.3c0-.663.537-1.2 1.2-1.2ZM9.99999 17.8c0-1.105.89501-2 2.00001-2s2 .895 2 2v2H9.99999v-2ZM12 13.8c1.105 0 2-.895 2-2s-.895-2-2-2-2.00001.895-2.00001 2 .89501 2 2.00001 2Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M12 2c.55 0 1 .44 1 1v.5h.5c.55 0 1 .44 1 1 0 .55-.45 1-1 1H13v.95996L20.05 11.16c.46.31.5901.93.2801 1.39-.29.44-.8801.58-1.3301.31V20h2c.55 0 1 .44 1 1 0 .55-.45 1-1 1H3c-.56 0-1-.45-1-1 0-.56.44-1 1-1h2v-7.45l-.46997.3c-.47.29-1.09001.15-1.38001-.32-.29-.47-.14993-1.09.32007-1.38L11 6.43994V5.5h-.5c-.56 0-1-.45-1-1 0-.56.44-1 1-1h.5V3c0-.56.44-1 1-1Zm3 18h2v-8.47l-5.0199-3.34006L7 11.3V20h2v-2c0-1.66 1.34-3 3-3 1.65 0 3 1.34 3 3v2Zm-1-8c0 1.1-.9 2-2 2-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2Zm-1 8v-2c0-.56-.45-1-1-1-.56 0-1 .44-1 1v2h2Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
